import React from "react";
import { IPaymentChoice } from "../classes/Domain";
import Utilities from "../classes/Utilities";

interface IState {

}

interface IProps {
    paymentChoice: IPaymentChoice;
    onSelected(paymentChoice: IPaymentChoice): void;
    isMostPopular?: boolean;
}

class PaymentChoice extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.onPaymentChoiceSelected = this.onPaymentChoiceSelected.bind(this);
    }

    onPaymentChoiceSelected() {
        this.props.onSelected(this.props.paymentChoice);
    }

    getIconClass() {
        return this.props.paymentChoice.payTermCd === 'FULL'
            ? "far fa-credit-card payment-icon-card"
            : "far fa-calendar-alt payment-icon-calendar";
    }

    render() {
        const { paymentChoice, isMostPopular } = this.props;
        const isSelected = paymentChoice.selected;

        return (
            <div
                className={`payment-option-card ${isSelected ? 'selected' : ''} ${isMostPopular ? 'has-badge' : ''}`}
                onClick={this.onPaymentChoiceSelected}
            >
                {isMostPopular && (
                    <div className="most-popular-badge">MOST POPULAR</div>
                )}

                <div className="payment-option-header d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div className="icon-container">
                            <i className={this.getIconClass()}></i>
                        </div>

                        <div className="title-block">
                            <h5 className="payment-title m-0">{paymentChoice.payTerm}</h5>
                            <p className="payment-subtitle m-0">
                                {paymentChoice.payPlanDesc}
                            </p>
                        </div>
                    </div>

                    <div className="selection-arrow">
                        <i className={`fas ${isSelected ? 'fa-check-circle payment-option-selected-check' : 'fa-chevron-right text-muted'}`}></i>
                    </div>
                </div>

                <hr className="payment-divider" />

                <div className="payment-breakdown">
                    <div className="breakdown-title text-uppercase text-center text-muted">
                        Payment Breakdown
                    </div>

                    {paymentChoice.payTermCd === 'FULL' ? (
                        <div className="d-flex flex-column align-items-center mt-2">
                            <span className="breakdown-label text-muted">Total Due Today</span>
                            <span className="breakdown-amount total-amount">
                                {Utilities.formatCurrency(paymentChoice.firstPay)}
                            </span>
                        </div>
                    ) : (
                        <div className="row text-center mt-2">
                            <div className="col-6 border-right">
                                    <span className="breakdown-label text-muted">
                                        {paymentChoice.payTermCd === 'BI-MONTHLY' ? 'First Payment' : 'First Month Payment'}
                                    </span>
                                <div className="breakdown-amount">
                                    {Utilities.formatCurrency(paymentChoice.firstPay)}
                                </div>
                            </div>
                            <div className="col-6">
                                <span className="breakdown-label text-muted">
                                    Then {paymentChoice.payCount} Payments of
                                </span>
                                <div className="breakdown-amount text-success">
                                    {Utilities.formatCurrency(paymentChoice.regularPay)}
                                    <span className="per-period">
                                        {paymentChoice.payTermCd === 'BI-MONTHLY' ? ' / every 15 days' : ' / month'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default PaymentChoice;